export default {
  base_url: '/api/illustrator/profile/portfolio/art-subjects',

  all() {
    return axios.get(this.base_url).then(response => response.data);
  },

};